// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2ddzN","vLegacy":"SelectSecondary_vLegacy__cZdN4","error":"SelectSecondary_error__152WG","disabled":"SelectSecondary_disabled__1MdaC"};